// @givmo/crm — the gift history an import brought for one of the organization's own contacts.
//
// The organization's old system's record, never Givmo giving, shown to read and never edited (a
// re-import never rewrites it either). Each amount in the currency the file gave it; lifetime giving
// and the largest gift one figure per currency, never added across currencies.

import { testIdProp } from '@givmo/design-system';
import type { CrmImportedContactOut } from './wire-types';
import { displayDate, displayImportedAmount } from './crm-decode';

export function ImportedGiftHistory({
  contact,
  testId,
}: {
  contact: CrmImportedContactOut;
  testId: string;
}) {
  const lastAmount =
    contact.last_gift_amount != null ? displayImportedAmount(contact.last_gift_amount) : null;
  const lastGift =
    lastAmount != null && contact.last_gift_date != null
      ? `${lastAmount} on ${displayDate(contact.last_gift_date)}`
      : (lastAmount ??
        (contact.last_gift_date != null ? displayDate(contact.last_gift_date) : null));
  const perCurrency = (amounts: CrmImportedContactOut['lifetime_giving']) =>
    amounts != null && amounts.length > 0 ? amounts.map(displayImportedAmount).join(', ') : null;
  const rows: [string, string | null][] = [
    ['Last gift', lastGift],
    ['First gift', contact.first_gift_date != null ? displayDate(contact.first_gift_date) : null],
    ['Lifetime giving', perCurrency(contact.lifetime_giving)],
    ['Largest gift', perCurrency(contact.largest_gift)],
  ];
  const shown = rows.filter((row): row is [string, string] => row[1] !== null);
  if (shown.length === 0) return null;
  return (
    <section className="flex flex-col gap-10" {...testIdProp(testId)}>
      <h3 className="font-sans text-s13 font-w600 tracking-givmo text-text-strong">
        Giving history from your import
      </h3>
      <dl className="grid grid-cols-[112px_1fr] gap-x-16 gap-y-8 font-sans text-s13 tracking-givmo">
        {shown.map(([label, value]) => (
          <div key={label} className="contents">
            <dt className="text-text-tertiary">{label}</dt>
            <dd className="text-text-strong tabular-nums">{value}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
